// extracted by mini-css-extract-plugin
export default {"container":"companyInfo_container__hFcDO","content":"companyInfo_content__nC-It","collapseContent":"companyInfo_collapseContent__3Th7Z"};